(() => {
  if (window.__customFooterStripAsteriskInit) {
    return;
  }
  window.__customFooterStripAsteriskInit = true;

  const targetSelector = '[data-custom-footer-strip]';
  const jumpSelector = '[data-custom-footer-strip-jump="true"]';
  const linkClass = 'custom-footer-strip-asterisk-link';
  const defaultTargetId = 'custom-footer-strip-target';

  const ignoredSelector = [
    targetSelector,
    'script',
    'style',
    'noscript',
    'textarea',
    'pre',
    'code',
    'svg',
    '[data-custom-footer-strip-skip]',
  ].join(',');

  const getTarget = () => document.querySelector(targetSelector);

  const shouldSkipNode = (node) => {
    const parent = node.parentElement;
    if (!parent) {
      return true;
    }
    if (parent.classList.contains(linkClass)) {
      return true;
    }
    return Boolean(parent.closest(ignoredSelector));
  };

  const createJumpLink = () => {
    const trigger = document.createElement('span');
    trigger.className = linkClass;
    trigger.textContent = '*';
    trigger.dataset.customFooterStripJump = 'true';
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-label', 'Jump to disclaimer');
    return trigger;
  };

  const replaceStarsInTextNode = (node) => {
    const text = node.nodeValue;
    if (!text || !text.includes('*')) {
      return;
    }

    const parts = text.split('*');
    if (parts.length <= 1) {
      return;
    }

    const fragment = document.createDocumentFragment();

    parts.forEach((part, index) => {
      if (part.length > 0) {
        fragment.appendChild(document.createTextNode(part));
      }

      if (index < parts.length - 1) {
        fragment.appendChild(createJumpLink());
      }
    });

    if (node.parentNode) {
      node.parentNode.replaceChild(fragment, node);
    }
  };

  const processAsteriskLinks = (root) => {
    if (!root) {
      return;
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || !node.nodeValue.includes('*')) {
          return NodeFilter.FILTER_REJECT;
        }
        if (shouldSkipNode(node)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    const candidateNodes = [];
    while (walker.nextNode()) {
      candidateNodes.push(walker.currentNode);
    }

    candidateNodes.forEach((node) => replaceStarsInTextNode(node));
  };

  const initLinks = () => {
    const target = getTarget();
    if (!target) {
      return;
    }

    if (!target.id) {
      target.id = defaultTargetId;
    }

    processAsteriskLinks(document.body);
  };

  const scrollToTarget = () => {
    const target = getTarget();
    if (!target) {
      return;
    }

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(jumpSelector);
    if (!trigger) {
      return;
    }
    if (!getTarget()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    scrollToTarget();
  });

  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest(jumpSelector);
    if (!trigger) {
      return;
    }

    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    scrollToTarget();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLinks);
  } else {
    initLinks();
  }

  document.addEventListener('shopify:section:load', initLinks);

  const observer = new MutationObserver((mutations) => {
    const target = getTarget();
    if (!target) {
      return;
    }

    if (!target.id) {
      target.id = defaultTargetId;
    }

    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((addedNode) => {
        if (addedNode.nodeType === Node.TEXT_NODE) {
          if (addedNode.parentElement) {
            processAsteriskLinks(addedNode.parentElement);
          }
          return;
        }

        if (addedNode.nodeType === Node.ELEMENT_NODE) {
          processAsteriskLinks(addedNode);
        }
      });
    });
  });

  const startObserver = () => {
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
